import styled from "styled-components";

const Box = styled.div`
  /* preventing border issues, if this is not set and we give width of 100% then it will take exact 100% width without taking padding in width*/
  box-sizing: border-box;
  /* if a row is in another row then it might grow/shrink*/
  flex-grow: 0;
  flex-shrink: 0;
`;

const Row = styled(Box)`
  display: flex;
  margin-top: ${({ marginTop }) => marginTop};
  align-items: ${({ alignItems }) => alignItems};
  justify-content: ${({ justifyContent }) => justifyContent};
`;

const Col = styled(Box)`
  display: flex;
  flex-direction: column;
`;

const CenteredRow = styled(Row)`
  align-items: center;
`;

const CenteredCol = styled(Col)`
  align-items: center;
`;

const CenterDiv = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export { Box, Row, Col, CenteredCol, CenteredRow, CenterDiv };
